const BRANDS = [
  { id: 'amex', re: /^3[47]/, lengths: [15], cvc: 4, gaps: [4, 10] },
  { id: 'diners', re: /^3(?:0[0-5]|095|[689])/, lengths: [14], cvc: 3, gaps: [4, 10] },
  { id: 'visa', re: /^4/, lengths: [16], cvc: 3, gaps: [4, 8, 12] },
  { id: 'mastercard', re: /^(?:5[1-5]|2(?:2[2-9]|[3-6]\d|7[01]|720))/, lengths: [16], cvc: 3, gaps: [4, 8, 12] },
  { id: 'discover', re: /^6(?:011|5|4[4-9])/, lengths: [16], cvc: 3, gaps: [4, 8, 12] },
]

export function digitsOf(value: string) {
  return (value || '').replace(/\D/g, '')
}

export function brandFor(digits: string) {
  if (!digits) return null
  return BRANDS.find((brand) => brand.re.test(digits)) || null
}

export function luhn(digits: string) {
  let sum = 0
  let alt = false
  for (let i = digits.length - 1; i >= 0; i -= 1) {
    let d = digits.charCodeAt(i) - 48
    if (alt) {
      d *= 2
      if (d > 9) d -= 9
    }
    sum += d
    alt = !alt
  }
  return digits.length > 0 && sum % 10 === 0
}

export function groupDigits(digits: string, gaps: number[]) {
  let out = ''
  for (let i = 0; i < digits.length; i += 1) {
    if (gaps.includes(i)) out += ' '
    out += digits.charAt(i)
  }
  return out
}

export function formatExpiry(raw: string) {
  let digits = digitsOf(raw).slice(0, 4)
  if (digits.length === 1 && /[2-9]/.test(digits)) digits = `0${digits}`
  return digits.length > 2 ? `${digits.slice(0, 2)}/${digits.slice(2)}` : digits
}
